import { render, staticRenderFns } from "./GeneralFields.vue?vue&type=template&id=6ea29d46&lang=pug"
import script from "./GeneralFields.vue?vue&type=script&lang=ts"
export * from "./GeneralFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports